import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";
import "../../../style/attendanceoveriew.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

const AttendanceOverview = ({ tasks = [] }) => {

  const chartData = useMemo(() => {
  if (!tasks.length) return { labels: [], datasets: [] };

  const monthNames = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec"
  ];

  const monthlyMap = {};

  tasks.forEach(task => {

    if (!task.fromDate) return;

    const date = new Date(task.fromDate);
    const year = date.getFullYear();
    const month = date.getMonth();
    const key = `${year}-${String(month + 1).padStart(2, "0")}`;

    if (!monthlyMap[key]) {
      monthlyMap[key] = {
        label: `${monthNames[month]} ${year}`,
        absent: 0,
        half: 0,
        present: 0,
        sortKey: new Date(year, month, 1)
      };
    }

    const days = Number(task.noOfDays) || 0;

    // 🟥 LEAVE
    if (task.leaveStatus == 1) {

      if (days === 0.5) {
        monthlyMap[key].half += 1;
      } else {
        monthlyMap[key].absent += days;
      }

    }

    // 🟢 DUTY
    else if (task.leaveStatus == 2) {

      if (days === 0.5) {
        monthlyMap[key].half += 1;
      } else {
        monthlyMap[key].present += days;
      }

    }

  });

  const sortedMonths = Object.values(monthlyMap)
    .sort((a, b) => a.sortKey - b.sortKey);

  return {
    labels: sortedMonths.map(m => m.label),
    datasets: [
      {
        label: "Absent Days",
        data: sortedMonths.map(m => m.absent),
        backgroundColor: "#ef4444",
        borderRadius: 8,
        barThickness: 36
      },
      {
        label: "Half Days",
        data: sortedMonths.map(m => m.half),
        backgroundColor: "#f59e0b",
        borderRadius: 8,
        barThickness: 36
      },
      {
        label: "Present Days",
        data: sortedMonths.map(m => m.present),
        backgroundColor: "#10b981",
        borderRadius: 10,
        barThickness: 36
      }
    ]
  };

}, [tasks]);


  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          boxWidth: 10
        }
      }
    },
    scales: {
      x: {
        stacked: true,
        grid: { display: false }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        max: 31,
        ticks: { stepSize: 5 },
        grid: { borderDash: [4, 4] }
      }
    }
  };

  return (
    <div className="card attendance-card">
      <div className="attendance-header">
        <i className="fas fa-user-check text-success"></i>
        <h5>Attendance Overview</h5>
      </div>

      <div style={{ height: "320px" }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default AttendanceOverview;
